import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";
import axios from "axios";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "@react-icons/all-files/bs/BsArrowRightShort";
import moment from "moment/moment";
import { motion } from "framer-motion";
import { LiveUrl } from "../../../apiUtils";

export const NoticeboardTab = () => {
  const [noticeBoard, setNoticeBoard] = useState([]);

  const fetchNews = () => {
    axios
      .get(`${LiveUrl}/api/noticeboard`)
      .then((response) => setNoticeBoard(response?.data?.data));
  };

  useEffect(() => {
    fetchNews();
  }, []);

  console.log("noticeBoard", noticeBoard?.[0]?._id);

  return (
    <div>
      <div className="mt-20 ml-3 flex justify-center pb-10 text-3xl font-bold md:text-5xl">
        <motion.div
          initial={{ opacity: 0, translateY: +60 }}
          whileInView={{ opacity: 1, translateY: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          key="modal"
        >
          <h1
            className=" border-l-2 border-[#32727A] pl-10 xs:pl-4  text-[#081C3A]"
            id="exploreNoticeboard"
          >
            Explore the <span className="pl-1 text-[#32727A]">Noticeboard</span>
          </h1>
        </motion.div>
      </div>
      <div className="noticeboard py-[36px] px-[30px] ">
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          // centeredSlides={true}
          // loop={true}
          navigation={{
            nextEl: ".swiper-navigation-next2",
            prevEl: ".swiper-navigation-prev2",
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {noticeBoard.length > 0 &&
            noticeBoard.map((newsObj, index) => (
              <SwiperSlide
                key={newsObj?._id}
                style={{
                  borderTop: "5px solid #081c3a",
                  marginRight: "4px",
                  display: "flex",
                  height: "auto",
                }}
              >
                <div className="flex flex-col flex-1 shadow-[1px_1px_3px_0_rgb(0,0,0,0.3)] mr-[1px] bg-white justify-between">
                  <div className="flex flex-col">
                    {/* Photo if uploaded */}
                    {newsObj?.media?.[0]?.url && (
                      <Link
                        to={`/Academics/AllNoticeBoard/${newsObj?._id}`}
                        onClick={() => {
                          window.scroll(0, 0);
                        }}
                        className="w-full h-[220px] overflow-hidden block bg-white"
                      >
                        <img
                          src={newsObj.media[0].url}
                          alt={newsObj.title}
                          className="w-full h-full object-contain hover:scale-105 transition-transform duration-300"
                        />
                      </Link>
                    )}

                    <div className="flex flex-row p-[10px] items-center">
                      <div className="flex flex-col border border-blue-400 w-[65px] sm:w-[82px] h-[80px] justify-center items-center bg-[#32727a] shrink-0">
                        <h3 className="text-[24px] font-bold text-[#fff]">
                          {moment(newsObj?.date).format("D")}
                        </h3>
                        <h3 className="text-base text-[#a1a1a1] leading-6 uppercase font-bold">
                          {moment(newsObj?.date).format("MMM")}
                        </h3>
                      </div>
                      <div className="text-[20px] font-bold text-[#333] ml-2 line-clamp-3">
                        {newsObj?.title}
                      </div>
                    </div>
                    <div className="flex p-[10px]">
                      <p
                        className="font-bold text-justify line-clamp-6 text-sm"
                        style={{
                          color: "rgba(81, 99, 129, 0.82)",
                        }}
                      >
                        {newsObj?.description}
                      </p>
                    </div>
                  </div>

                  {/* Links */}
                  <div
                    className="flex p-[10px] justify-between border-t border-gray-100"
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                  >
                    <Link to={`/Academics/AllNoticeBoard/${newsObj?._id}`}>
                      <div className="text-sm font-semibold text-[#32727a] hover:underline">Know More</div>
                    </Link>
                    <Link to={`/Academics/AllNoticeBoard/${newsObj?._id}`}>
                      <div className="flex h-full items-center">
                        <BsArrowRightShort className="flex justify-center items-center text-[22px] text-[#081c3a]" />
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          {/* _______________Buttons_________________ */}
          <div className="flex justify-center items-center gap-4 mt-8">
            <div className="swiper-navigation-prev2 flex h-[50px] w-[50px] items-center justify-center bg-white border border-gray-200 rounded-full shadow-md cursor-pointer hover:bg-[#32727a] hover:border-[#32727a] hover:scale-105 transition-all duration-300 group">
              <svg className="w-6 h-6 text-[#081c3a] group-hover:text-white transition-colors" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
              </svg>
            </div>
            <div className="swiper-navigation-next2 flex h-[50px] w-[50px] items-center justify-center bg-white border border-gray-200 rounded-full shadow-md cursor-pointer hover:bg-[#32727a] hover:border-[#32727a] hover:scale-105 transition-all duration-300 group">
              <svg className="w-6 h-6 text-[#081c3a] group-hover:text-white transition-colors" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  );
};
